export default __webpack_public_path__ + "static/media/PAULAS CHOICE INTERVIEW_FINWEB.1fc1bb6b.png";